<template>
	<core-modal
		:name="campaign.id + '-duplicate-modal'"
		class="omapi-modal duplicate-modal"
		:click-to-close="!isCreatingDuplicate"
		:child-refs="$refs"
		@before-open="beforeOpen"
	>
		<template #header>
			<svg-duplicate />
			Create Duplicate
		</template>

		<modals-content>
			<transition name="component-fade-slow">
				<core-alert v-if="error" class="error">{{ error }}</core-alert>
			</transition>

			<p>
				Create a Duplicate of the <strong>{{ campaign.name }}</strong> campaign.
			</p>

			<form class="omapi-modal-form" @submit.prevent="duplicate">
				<section class="omapi-modal-form__section">
					<label :for="campaign.id + '-name'">Name</label>
					<input
						:id="campaign.id + '-name'"
						ref="toFocus"
						v-model="name"
						type="text"
						placeholder="Enter a name for your duplicate campaign..."
					/>
				</section>

				<section class="omapi-modal-form__section">
					<label :for="campaign.id + '-notes'">Notes</label>
					<textarea
						:id="campaign.id + '-notes'"
						v-model="notes"
						placeholder="Enter some notes about this duplicate campaign..."
					/>
				</section>

				<section v-if="availableTypes.length" class="omapi-modal-form__section">
					<label :for="campaign.id + '-type'">Campaign Type</label>
					<select
						:id="campaign.id + '-type'"
						v-model="type"
						:name="campaign.id + '-type'"
						required="required"
						placeholder="Select a Campaign Type"
					>
						<option
							v-for="campaignType in availableTypes"
							:key="campaignType.value"
							:value="campaignType.value"
						>
							{{ campaignType.name }}
						</option>
					</select>
				</section>

				<section
					v-if="allowed('features', 'mobile-campaigns')"
					v-show="canMobile"
					class="omapi-modal-form__section"
				>
					<label :for="campaign.id + '-mobile-toggle'"> Mobile Campaign </label>
					<common-toggle-input
						:id="campaign.id + '-mobile-toggle'"
						v-model="mobile"
						:name="campaign.id + '-mobile-toggle'"
						wrap-tag="span"
						on-text="Yes"
						off-text="No"
					/>
				</section>

				<section class="buttons">
					<core-loading-button
						class="duplicate-campaign"
						size="large"
						color="blue"
						button-type="submit"
						:loading="isCreatingDuplicate"
					>
						Create Duplicate
					</core-loading-button>
					<core-button
						size="large"
						button-type="button"
						:disabled="isCreatingDuplicate"
						@click.prevent="$modal.hide(campaign.id + '-duplicate-modal')"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { duplicate } from '@/campaigns/mixins/duplicate';

export default {
	mixins: [duplicate],
	props: {
		campaign: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			name: '',
			mobile: false,
			type: '',
			notes: null,
			error: null,
		};
	},
	computed: {
		...mapGetters(['allowed']),
		...mapState('templates', ['permittedTypes', 'types']),
		availableTypes() {
			return this.permittedTypes
				.filter((type) => {
					return !!this.types[type];
				})
				.map((type) => {
					return {
						value: type,
						name: this.types[type].name,
					};
				});
		},
	},
	beforeDestroy() {
		this.error = null;
		this.name = null;
		this.notes = null;
	},
	methods: {
		beforeOpen() {
			this.name = `${this.campaign.name} - Copy`;
			this.mobile = Boolean(this.campaign.is_mobile);
			const type = this.availableTypes.find((t) => t.name === this.campaign.type);
			this.type = type ? type.value : '';
		},
	},
};
</script>
